import {Offer} from '../../core/models/offer/offer.model';
import {OfferCoverageDestinyCode} from '../../core/enums/offer/offer-coverage-destiny-code.enum';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

export class OfferUtils {

    static getSelectedPrimaryCoveragesLabels(offer: Offer, lang: string): string[] {
        const COVERAGES_ORDER  = ['OC', 'AC', 'AC_MINI', 'NNW', 'ASSISTANCE'];
        return offer.coverages
            .sort((a, b) => {
                const coverageAIndex = COVERAGES_ORDER.findIndex(coverageCode => coverageCode === a.code);
                const coverageBIndex = COVERAGES_ORDER.findIndex(coverageCode => coverageCode === b.code);
                return coverageAIndex - coverageBIndex;
            })
            .map(coverage => coverage.destinies.find(destiny => destiny.code === OfferCoverageDestinyCode.PRIMARY_BOX))
            .filter(destiny => {
                if (isNotNullOrUndefined(destiny)) {
                    const selectedOption = destiny.options.find(option => option.code === destiny.selectedOption);
                    const selectedValue = selectedOption.values.find(value => value.languageCode.toUpperCase() === lang.toUpperCase());
                    return selectedValue.value;
                }
                return false;
            })
            .map(destiny => {
                const destinyLabel = destiny.labels.find(label => label.languageCode.toUpperCase() === lang.toUpperCase());
                return destinyLabel ? destinyLabel.label : null;
            })
            .filter(label => isNotNullOrUndefined(label));
    }
}
